import PropTypes from 'prop-types';
import cx from 'classnames';
import {Button} from '../atoms/Button';
import {ArrowIcon} from '../svg/ArrowIcon';

export const Pagination = (props) => {
  const {currentPage, totalPages} = props;

  const maxPagesToShowCount = evite.detects.isMobile ? 5 : 10; // todo dynamic value based on visible area?
  let numsToShow = [];

  const range = (startAt = 0) =>
    // returns array w/ length of maxPagesToShowCount, w/ a range of nums starting at the num passed in
    [...Array(Math.min(maxPagesToShowCount, totalPages)).keys()].map((i) => i + startAt);
  const getWhichNumsToShow = (curr_page) => {
    if (totalPages <= maxPagesToShowCount) {
      // total is less than max we can fit, so show all available page numbers
      numsToShow = range(1);
    } else if (curr_page <= Math.ceil(maxPagesToShowCount / 2)) {
      // current page is less than half of max we can fit, so show nums up to the max
      numsToShow = range(1);
    } else if (
      curr_page >= Math.ceil(maxPagesToShowCount / 2) &&
      curr_page <= totalPages - Math.ceil(maxPagesToShowCount / 2)
    ) {
      // curr page is bigger than the max num AND there are more pages to show, so put current page in the middle of the array
      numsToShow = range(curr_page - Math.ceil(maxPagesToShowCount / 2) + 1);
    } else {
      // otherwise, near the end of the total pages, show as many as we can fit up to the total pages available
      numsToShow = range(totalPages - maxPagesToShowCount + 1);
    }
  };

  getWhichNumsToShow(currentPage);

  const handlePageNumClick = (e, p) => {
    if (!evite.hasClass(e.currentTarget, 'active')) {
      props.onPagePress(p);
    }
  };

  return (
    <div className={cx('pagination__wrapper', props.className)}>
      {currentPage > 1 && (
        <Button
          variant="transparent"
          className="pagination__arrow-left"
          onClick={props.onLeftArrowPress}
          data-qa-id="button-previous"
        >
          <ArrowIcon ratio={0.5} />
        </Button>
      )}
      {numsToShow.map((p) => (
        <Button
          variant="transparent"
          className={`pagination__number ${currentPage === p ? 'active' : ''}`}
          onClick={(e) => handlePageNumClick(e, p)}
          data-qa-id={`button-page-${p}`}
          key={`pagination_page_${p}`}
        >
          {p}
        </Button>
      ))}
      {currentPage < totalPages && (
        <Button
          variant="transparent"
          className="pagination__arrow-right"
          onClick={props.onRightArrowPress}
          data-qa-id="button-next"
        >
          <ArrowIcon ratio={0.5} />
        </Button>
      )}
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPagePress: PropTypes.func,
  onLeftArrowPress: PropTypes.func,
  onRightArrowPress: PropTypes.func,
};
